module.exports = __webpack_public_path__ + "static/img/Ruanyangyang.026746d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ruanyangyang.jpg
// module id = 766
// module chunks = 1